import { render, staticRenderFns } from "./VesselSpecificAssessment.vue?vue&type=template&id=3e80f072"
import script from "./VesselSpecificAssessment.vue?vue&type=script&lang=js"
export * from "./VesselSpecificAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports